import Link from 'next/link'
import { PUBLIC_LANDING_ROUTES } from '@/setup/routing/routing'

/**
 * Agency routing note under the home hero's CTA pair — the point where an agency/freelancer
 * decides which path is theirs. One quiet line: ash copy, orange link to /groups/agency.
 */
export function LpAgencyHeroNote() {
    return (
        <p className="mt-4 text-[13.5px]! leading-[1.4]! text-[#746C64]">
            Running an agency or multiple brands?{' '}
            <Link
                href={PUBLIC_LANDING_ROUTES.AGENCY}
                className="group whitespace-nowrap font-medium text-[#FF5500]"
            >
                Superscale for Agencies{' '}
                <span className="inline-block transition-transform duration-150 group-hover:translate-x-0.5">→</span>
            </Link>
        </p>
    )
}
